/** Pinata URLs — see KVH/files/KAVACH-LOGOS-GUIDE.md; MTS metadata: 815s/Pinata_Download/mts.json */

/** Kavachswap on X */
export const KAVACH_X_URL = 'https://x.com/kavachswap16098' as const
/** Mantis Shrimp on X */
export const MANTIS_X_URL = 'https://x.com/1mantisshrimp' as const

export const BRAND = {
  /** Header mark — **6k**; KVH/files/KAVACH-LOGOS-GUIDE.md (moccasin Pinata 019d0238-7093-759b-ad2a-89021ca621dc) */
  headerLogo:
    'https://moccasin-holy-ptarmigan-404.mypinata.cloud/ipfs/bafybeidluj4wzkjqa6hgmcl6zqsuow27jhtaytnlpj5nqzltnq5nc4zx6y',
  /** Next to Connect / top-right cluster — KAVACH-LOGOS-GUIDE.md "Header (next to Connect Wallet)" */
  headerMarkNextToWallet:
    'https://moccasin-holy-ptarmigan-404.mypinata.cloud/ipfs/bafybeibhbkop7ugpfh4qpeoyp3dnrslhkx3gcicaism75rifuf6qfrajgm',
  /** Logo 2 — alternate / legacy */
  logo2: 'https://tomato-impossible-warbler-875.mypinata.cloud/ipfs/bafybeigg22bu3otiqneqyavdmlioynyy42zebfv6ffx342hyozdspwih7u',
  /** Art 3 — ghost / decorative background texture */
  decorGhost: 'https://tomato-impossible-warbler-875.mypinata.cloud/ipfs/bafybeiar2zp72gzndcbeti6ffppdmovhsx4sqw723yn7m7nw2wklijlqry',
  /** Settings nav — archived Green (tomato gateway); Pinata 019cf294-b80b-7b37-8b13-6242cba0c4eb */
  settingsNavLogo:
    'https://tomato-impossible-warbler-875.mypinata.cloud/ipfs/bafybeih2v2caps7rsz27xxez7i5eh2tfolhiivyrddk5city2objtrgpim',
  /** X cluster — Label **3** (Art 3 / black decorative); left of @handles in AppShell + Dashboard */
  twitterNavIcon:
    'https://tomato-impossible-warbler-875.mypinata.cloud/ipfs/bafybeiar2zp72gzndcbeti6ffppdmovhsx4sqw723yn7m7nw2wklijlqry',
  /** Home “Trade” card — KAVACH-LOGOS-GUIDE “Home Trade card (EVM)” */
  homeSwapCardImage:
    'https://moccasin-holy-ptarmigan-404.mypinata.cloud/ipfs/bafybeihillwg52q3wugnggvtpbruq46qw3yht7h2cczv6mu5d2i42fehkq',
  /** Home “Liquidity” card — KAVACH-LOGOS-GUIDE “Home Liquidity card (EVM)” */
  homeLiquidityCardImage:
    'https://moccasin-holy-ptarmigan-404.mypinata.cloud/ipfs/bafybeiekddwrhkvbciorf3hlx6y6kthqcw3l6xxx4cwgqqi3hdphgih7zu',
  /**
   * 3D hero GLB — KAVACH-LOGOS-GUIDE.md “3d glb” (Moccasin Pinata).
   * Override with `VITE_HERO_MANTIS_GLB` (full URL). Loader tries Pinata → ipfs.io → `/3dmantis.glb`.
   */
  heroMantisGlb:
    'https://moccasin-holy-ptarmigan-404.mypinata.cloud/ipfs/bafybeiccprbsla7hccyhkel5dtw7zwnxr7pcgwt5dqitse7qnm67h7t7ey',
} as const

/** Same CID as `heroMantisGlb` — public gateway fallback (KAVACH-LOGOS-GUIDE “IPFS Gateway Fallback”). */
export const HERO_MANTIS_GLB_CID =
  'bafybeiccprbsla7hccyhkel5dtw7zwnxr7pcgwt5dqitse7qnm67h7t7ey' as const
